import React from "react";
import AntdResult, { ResultType, ExceptionMap } from "antd/lib/result";

const Result: ResultType = props => <AntdResult {...props}></AntdResult>

Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
Result.PRESENTED_IMAGE_500 = ExceptionMap[500];

Result.defaultProps = {
    status: 'info',
  };
  
export default Result;


// WEBPACK FOOTER //
// ./src/components/result/index.tsx